<template>
  <!-- 校本抢课简单选课 -->
  <div class="choseCourse clearfix">
    <div class="fl" v-if="list">
      <van-sidebar v-model="activeKey" @change="getIndex">
        <van-sidebar-item
          v-for="item in list"
          :key="item.SubjectGroupID"
          :title="item.SubjectGroupName"
        ></van-sidebar-item>
      </van-sidebar>
    </div>
    <div class="content fr" style="margin-bottom: 65px;" v-if="list.length>0" >
      <div class="content-header">
        <!-- <p>{{list[0].SubjectGroupName}}</p> -->
        <p>
          本次最少选
          <span>{{minNum}}</span>门，最多选
          <span>{{maxNum}}</span>门
        </p>
      </div>
      <div class="content-main">
        <div class="course" v-for="item in list[activeKey].Courses" :key="item.AID">
          <div>
            <span>{{item.SubjectName}}</span>
            <!-- <img :src="igmUrl" alt /> -->
            <p class="teacher" >
              教师名称：{{item.TeacherName?item.TeacherName:'无'}}
            </p>
            <p class="current">当前已选：{{item.SelectCount}}/{{item.StudentLimitation}}人</p>
            <p class="current">上课时间：{{item.TimesInfo}}</p>
            <div class="op-btn">
              <div class="introduce-btn" v-if="item.IsExistsCourseIntroduction" @click="lntroduce(item)">课程介绍</div>
              <div>
                <div class="btn" v-if="!item.IsSelected" @click="chose(item)">选择</div>
                <div class="btn2" v-if="item.IsSelected" @click="chose(item)">已选</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <SingleBottomBtn @clickBtn="complete" v-if="list.length>0">完成</SingleBottomBtn>
  </div>
</template>
<script>
import { Notify } from "vant";
const courseUrl = require("@/assets/csmsTimeTable/onlineCourseSelection/course-class-img.png");
import SingleBottomBtn from "@/components/SingleBottomBtn";

export default {
  components: {
    SingleBottomBtn
  },
  data() {
    return {
      igmUrl: courseUrl,
      activeKey: 0,
      list: [],
      minNum: "",
      maxNum: "",
      crouseList: [],
      accountID: 0,
      ticket: '',
      classTableID:0,
    };
  },
  created() {
    this.classTableID=this.$store.state.csmstimetable.online.ClassTableID
    this.collectionID=this.$store.state.csmstimetable.online.CollectionID
    this.getSubjec('fir');
  },
  methods: {
    getIndex(_index) {
      this.activeKey = _index;
    },
    async getSubjec(type) {
      if(type === 'fir'){
        this.xy.loading()
      }
      let res = await this.xyapi.get(
        this.$store.state.apiPath +
          "/api/StudentOnLineSelectCourse/GetSchoolBasedGrabOnLineList",
        {
          classTableID: this.classTableID,
          isShow: false,
          studentID: 0
        }
      );
      if (res.success) {
        if (res.data.Results.length) {
          this.crouseList = res.data
          this.list = res.data.Results;
          if(this.activeKey >= this.list.length){
            this.activeKey = this.list.length -1;
          }
          this.minNum = res.data.MinOptionalCourse;
          this.maxNum = res.data.MaxOptionalCourse;
          this.accountID = res.data.AccountID;
        }
      }
      this.xy.unloading()
    },
     // 课程介绍
    async lntroduce (item) {
       this.xy.loading()
        let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/StudentOnLineSelectCourse/GetCourseIntroduction`, { classTableID: this.classTableID, aid: item.AID, type: item.Type })
        this.xy.unloading()
        if (res.success) {
          if(res.data.IsUrl){
            window.open(res.data.Description)
          }else{
            this.$router.push({
              name:'choseCourseSchoolLntroduce',
              query:{
                classTableID:this.classTableID,
                introduce:item
              }
            });
          }
        }
    },
    async chose(i) {
      if (i.IsChoice) {
        if (!i.IsSelected) {// 选中
          this.xy.loading()
          let res1 = await this.xyapi.get(`${this.xyMApi}/generate/api/Generate/Generate`, {
            accountID: this.accountID,
            classTableID: this.classTableID,
            aid: i.SelectCourseAID,
            studentID: i.SubjectID,
            studentOrganizationID: i.StudentOrganizationID
          })
          if (res1.success) {
            this.ticket = res1.data
            let res = await this.xyapi.post(
            this.$store.state.apiPath + "/api/StudentOnLineSelectCourse/SchoolBasedGrabSelect", {
              ClassTableID: this.classTableID,
              AID: i.AID,
              CoursePlanID: i.CoursePlanID,
              Type: i.Type,
              SelectAID: i.SelectiveAID,
              // SelectiveCourse: i.SelectiveCourse,
              SelectType: i.SelectiveType,
              StudentID: i.SubjectID,
              ticket: this.ticket
            });
            if (res.success) {
              this.getSubjec();
            } else {
              // 选择失败后释放名额
              let resRemove = await this.xyapi.get(`${this.xyMApi}/generate/api/Generate/Remove`, {
                accountID: this.accountID,
                classTableID: this.classTableID,
                aid: i.SelectCourseAID,
                studentID: i.SubjectID,
                studentOrganizationID: i.StudentOrganizationID
              })
              if (resRemove.success) {
                //
              }
              this.xy.unloading()
            }
          }else{
            this.xy.unloading()
          }
        } else {//取消选中
          this.xy.loading()
          let res1 = await this.xyapi.get(`${this.xyMApi}/generate/api/Generate/Remove`, {
            accountID: this.accountID,
            classTableID: this.classTableID,
            aid: i.SelectCourseAID,
            studentID: i.SubjectID,
            studentOrganizationID: i.StudentOrganizationID
          })
          if (res1.success) {
            this.ticket = res1.data
            let res = await this.xyapi.post(
            this.$store.state.apiPath + "/api/StudentOnLineSelectCourse/SchoolBasedGrabUnSelect",{
              ClassTableID: this.classTableID,
              AID: i.AID,
              CoursePlanID: i.CoursePlanID,
              Type: i.Type,
              SelectAID: i.SelectiveAID,
              // SelectiveCourse: i.SelectiveCourse,
              SelectType: i.SelectiveType,
              StudentID: i.SubjectID,
              ticket: this.ticket
            });
            if (res.success) {
              this.getSubjec();
            }else{
              this.xy.unloading()
            }
          }else{
            this.xy.unloading()
          }
        }
      }
    },
    async complete() {
      if (this.crouseList.SelfSelectCount > this.crouseList.MaxOptionalCourse) {
        Notify({
          type: "danger",
          message: "最多选择" + this.crouseList.MaxOptionalCourse + "门"
        });
        return false;
      }
      if (this.crouseList.SelfSelectCount < this.crouseList.MinOptionalCourse) {
        Notify({
          type: "danger",
          message: "请至少选择" + this.crouseList.MinOptionalCourse + "门"
        });
        return false;
      }
      for (var i = 0; i < this.crouseList.Results.length; i++) {
        if (
          this.crouseList.Results[i].SelectNum >
          this.crouseList.Results[i].MaxSubjectNum
        ) {
          Notify({
            type: "danger",
            message:
              this.crouseList.Results[i].SubjectGroupName +
              "最多选择" +
              this.crouseList.Results[i].MaxSubjectNum +
              "门"
          });
          return false;
        }
        if (
          this.crouseList.Results[i].SelectNum <
          this.crouseList.Results[i].MinSubjectNum
        ) {
          Notify({
            type: "danger",
            message:
              this.crouseList.Results[i].SubjectGroupName +
              "请至少选择" +
              this.crouseList.Results[i].MinSubjectNum +
              "门"
          });
          return false;
        }
      }
      let res = await this.xyapi.post(
        this.$store.state.apiPath +
          "/api/StudentOnLineSelectCourse/SchoolBasedGrabCompleteSelectCourse",
        {
          ClassTableID: this.classTableID,
          StudentID: 0,
          CollectionID: this.collectionID
        }
      );
      if (res.success) {
        this.$router.push(`/home/onlineChoseClass`);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.choseCourse {
  width: 100%;
  .van-sidebar{
    width: 100%;
  }
  .van-sidebar-item--select {
    color: #323233;
    font-weight: 500;
    border-color: #4196ff;
  }
  .van-sidebar-item {
    border-bottom: 1px solid #e6e6e6;
    line-height: inherit;
  }
  .fl {
    width: 20%;
    margin-bottom: 110px;
    background: rgba(249, 249, 249, 1);
    box-shadow: 0px 4px 8px 0px rgba(151, 151, 151, 0.2);
  }
  .fr {
    width: 78%;
    margin: 10px auto;
  }
  .content {
    background-color: #fff;
    .content-header {
      padding: 15px 0 20px 20px;
      height: 100px;
      width: 100%;
      background-image: url("./../../../../assets/csmsTimeTable/onlineCourseSelection/conheader.png");
      background-size: cover;
      line-height: 35px;
      p:nth-child(1) {
        font-size: 26px;
        color: rgba(51, 51, 51, 1);
      }
      p:nth-child(2) {
        font-size: 22px;
        color: rgba(153, 153, 153, 1);
      }
      p {
        span {
          color: #545efa;
          font-weight: bold;
        }
      }
    }
    .content-main {
      text-align: center;
      p:nth-child(1) {
        font-size: 28px;
        color: #1d2157;
        font-weight: bold;
      }
      p:nth-child(2) {
        font-size: 22px;
        color: rgba(153, 153, 153, 1);
        line-height: 35px;
      }
      p {
        span {
          color: #545efa;
          font-weight: bold;
        }
      }
      .course:last-child{
        margin-bottom: 120px;
      }
      .course {
        // padding-left: 30px;
        // margin-top: 20px;
        // padding-top: 25px;
        padding: 25px 30px 0 30px;
        border-top: 1px solid #e6e6e6;
        text-align: left;
        // border-bottom: 1px solid #e6e6e6;
        .op-btn{
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin: 8px 0;
          .introduce-btn{
            background: #4196ff;
            padding: 0 10px;
            height: 52px;
            border-radius: 26px;
            line-height: 52px;
            text-align: center;
            font-weight: normal;
            font-size: 24px;
            font-weight: 400;
            color: #fff;
          }
          .btn-disabled{
            background: #dddd;
          }
        }
        div {
          position: relative;
          // height: 150px;
          img {
            position: absolute;
            width: 58px;
            height: 64px;
            left: 0;
            top: 25%;
          }
          .teacher {
            // position: absolute;
            // left: 20%;
            // top: 30%;
            font-size: 22px;
            text-align: left;
            font-weight: normal;
            margin: 5px 0;
            color: #999999;
          }
          .current {
            // position: absolute;
            // left: 20%;
            // top: 50%;
            font-size: 22px;
            text-align: left;
            font-weight: normal;
            color: #999999;
            margin: 5px 0;
          }
          .btn {
            // position: absolute;
            // right: 5%;
            // top: 25%;
            width: 124px;
            height: 52px;
            border: 1px solid rgba(255, 149, 0, 1);
            box-shadow: 0px 4px 8px 0px rgba(228, 111, 86, 0.5);
            border-radius: 26px;
            line-height: 52px;
            text-align: center;
            font-weight: normal;
            font-size: 24px;
            font-weight: 400;
            color: rgba(246, 141, 5, 1);
          }
          .btn2 {
            // position: absolute;
            // right: 5%;
            // top: 25%;
            width: 124px;
            height: 52px;
            background: rgba(255, 149, 0, 1);
            box-shadow: 0px 4px 8px 0px rgba(228, 111, 86, 0.5);
            border-radius: 26px;
            line-height: 52px;
            text-align: center;
            font-weight: normal;
            font-size: 24px;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>